export function buildToLocationFilterTreeData(toLocationFilters = {}) {
  return Object.entries(toLocationFilters)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([locationName, locationValue]) => {
      const sublocations = Array.isArray(locationValue?.sublocations)
        ? locationValue.sublocations
        : [];

      return {
        title: locationName,
        value: JSON.stringify({
          type: "location",
          locationName,
        }),
        key: `location-${locationName}`,
        children: sublocations.map((subLocation) => ({
          title: subLocation,
          value: JSON.stringify({
            type: "sublocation",
            locationName,
            subLocation,
          }),
          key: `sublocation-${locationName}-${subLocation}`,
        })),
      };
    });
}

export function matchesToLocationFilter(item, selectedToLocationFilter) {
  if (!selectedToLocationFilter) {
    return true;
  }

  try {
    const parsedFilter = JSON.parse(selectedToLocationFilter);

    if (parsedFilter?.type === "location") {
      return item.toLocation === parsedFilter.locationName;
    }

    if (parsedFilter?.type === "sublocation") {
      return (
        item.toLocation === parsedFilter.locationName &&
        item.toSubLocation === parsedFilter.subLocation
      );
    }
  } catch (error) {
    console.log("Failed to parse toLocation filter:", error);
  }

  return true;
}
